import { render, staticRenderFns } from "./FiltroPesquisaProcesso.vue?vue&type=template&id=1ae8f83a&scoped=true"
import script from "./FiltroPesquisaProcesso.vue?vue&type=script&lang=js"
export * from "./FiltroPesquisaProcesso.vue?vue&type=script&lang=js"
import style0 from "./FiltroPesquisaProcesso.vue?vue&type=style&index=0&id=1ae8f83a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae8f83a",
  null
  
)

export default component.exports